/**
 * SessionUtil 本地session工具类
 *
 * @Author  Yee
 * @DATE    create on 2019/9/6
 * @DESC
 */
import { getSession, setSession } from './index';
import { APP_VAR } from '../appConstant';

const SessionUtil = {
  /**
   * 设置用户、设备信息
   * @param data
   */
  setAppEnv (data) {
    setSession(APP_VAR.APP_ENV_INFO, JSON.stringify(data))
  },
  /**
   * 获取用户、设备信息
   * @return {string}
   */
  getAppEnv () {
    return getSession(APP_VAR.APP_ENV_INFO)
  },

  /**
   * 获取用户,设备信息
   * @returns {any} 返回字符串解析的 json 对象
   */
  getAppEnvObject () {
    return JSON.parse(this.getAppEnv() || '[]')
  }
}

export default SessionUtil
